/**
 * combo-remove.js — Combo Special cascade removal helpers.
 * Loaded globally (layout/theme.liquid) so the minicart on ANY page can
 * cascade-remove a combo parent + children. cart.js (cart page only) uses
 * these same globals. Do not redefine cwComboRemove/cwGetItemProp elsewhere.
 */
// ── Combo Special helpers ──────────────────────────────────────────────────
function cwGetItemProp(item, key) {
  if (!item || !item.properties) return null;
  var pair = Object.entries(item.properties).find(function(p) { return p[0] === key; });
  return pair ? pair[1] : null;
}

// Remove combo parent + all children when Remove is clicked.
// Removes all items atomically by key via /cart/update.js, requesting the
// re-rendered cart section HTML back in the response, then swaps it into
// the DOM in place — no page reload.
// Falls back to proceed() for non-combo items and to a reload on error.
function cwComboRemove(lineIndex, proceed) {
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // lineIndex is a 1-based line number on the cart page, but the minicart
      // passes item.key (e.g. "45123456789:abc…"). Keys always contain ':',
      // line numbers never do — resolve accordingly.
      var raw = String(lineIndex);
      var removingItem = null;
      if (raw.indexOf(':') !== -1) {
        for (var ci = 0; ci < cart.items.length; ci++) {
          if (cart.items[ci].key === raw) { removingItem = cart.items[ci]; break; }
        }
      } else {
        removingItem = cart.items[parseInt(raw, 10) - 1];
      }
      var group = removingItem && cwGetItemProp(removingItem, '_combo_group');
      var isChild = removingItem && cwGetItemProp(removingItem, '_combo_child') === 'true';
      if (!group || isChild) { proceed(); return; }

      // Build key-based updates for parent + all children in one atomic call.
      // Using keys avoids the line-number-shift bug that occurs when children
      // are removed first and the parent moves to a different position.
      var updates = {};
      updates[removingItem.key] = 0;
      cart.items.forEach(function(item) {
        if (cwGetItemProp(item, '_combo_child') === 'true' &&
            cwGetItemProp(item, '_combo_group') === group) {
          updates[item.key] = 0;
        }
      });

      var cartItems = document.querySelector('cart-items');
      var mainCartItems = document.getElementById('main-cart-items');
      var sectionId = mainCartItems ? mainCartItems.dataset.id : null;
      var cartNotification = document.querySelector('cart-notification');

      // Ask Shopify to render the updated cart section(s) and return the HTML,
      // so we can swap them in without reloading (same pattern updateQuantity uses).
      // Include both the cart page section (if present) and the minicart section
      // so whichever is on screen updates correctly.
      var sectionsToRequest = [];
      if (sectionId) sectionsToRequest.push(sectionId);
      sectionsToRequest.push('minicart-form');

      var body = {
        updates: updates,
        sections: sectionsToRequest,
        sections_url: window.location.pathname
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      })
      .then(function(r) { return r.json(); })
      .then(function(parsedState) {
        if (!parsedState || !parsedState.sections) {
          window.location.reload();
          return;
        }

        var didRender = false;

        // Update header/mini cart counts (always safe to do)
        document.querySelectorAll('.cart-count').forEach(function(el) {
          if (el.classList.contains('cart-count-drawer')) {
            el.innerHTML = '(' + parsedState.item_count + ')';
          } else {
            el.innerHTML = parsedState.item_count > 100 ? '~' : parsedState.item_count;
          }
        });
        var headerTotal = document.querySelector('header-total-price');
        if (headerTotal && typeof headerTotal.updateTotal === 'function') {
          headerTotal.updateTotal(parsedState);
        }

        // 1. Cart page section (if we're on the cart page)
        if (cartItems && mainCartItems && sectionId && parsedState.sections[sectionId]) {
          var sectionHtml = parsedState.sections[sectionId];
          if (parsedState.item_count === 0) {
            mainCartItems.innerHTML = cartItems.getSectionInnerHTML(sectionHtml, '#main-cart-items');
          } else {
            var jsContents = mainCartItems.querySelector('.js-contents') || mainCartItems;
            jsContents.innerHTML = cartItems.getSectionInnerHTML(sectionHtml, '.js-contents');

            // Totals block
            try {
              var totals = cartItems.getSectionInnerHTML(sectionHtml, '.cart-info .totals');
              var totalsContent = document.querySelector('.cart-info .totals');
              if (totals && totalsContent) totalsContent.innerHTML = totals;
            } catch (e) { /* selector not found — ignore */ }

            // Free-shipping progress bar
            var cartFreeShip = document.querySelector('free-ship-progress-bar');
            if (cartFreeShip && typeof cartFreeShip.init === 'function') {
              cartFreeShip.init(parsedState.items_subtotal_price);
            }
          }
          didRender = true;
        }

        // 2. Minicart section (if present on page — any page).
        // Mirror CartNotification.updateQuantity exactly: replace ONLY the
        // inner contents of #minicart-form. The drawer wrapper, its 'open'
        // class, and the page overlay wiring live OUTSIDE that element and
        // must survive the swap — replacing the whole .shopify-section
        // destroys the open drawer and strands the dark overlay.
        if (cartNotification && parsedState.sections['minicart-form']) {
          try {
            var mfTarget = document.getElementById('minicart-form');
            var mfDoc = new DOMParser().parseFromString(parsedState.sections['minicart-form'], 'text/html');
            var mfSource = mfDoc.querySelector('#minicart-form');
            if (mfTarget && mfSource) {
              mfTarget.innerHTML = mfSource.innerHTML;
              // Re-bind handlers inside the re-rendered content, same as the
              // theme does at the end of updateQuantity.
              if (typeof cartNotification.cartAction === 'function') {
                cartNotification.cartAction();
              }
              var mfFreeShip = document.querySelector('free-ship-progress-bar');
              if (mfFreeShip && typeof mfFreeShip.init === 'function') {
                mfFreeShip.init(parsedState.items_subtotal_price);
              }
              didRender = true;
            }
          } catch (e) {
            console.warn('cwComboRemove: minicart re-render skipped:', e);
          }
        }

        if (!didRender) {
          // Nothing we recognized was on the page — reload as a last resort.
          window.location.reload();
          return;
        }

        // Re-init lazy-loaded images in the re-rendered content
        if (typeof BlsLazyloadImg !== 'undefined' && BlsLazyloadImg.init) {
          BlsLazyloadImg.init();
        }
      })
      .catch(function(e) {
        console.error('cwComboRemove re-render failed, falling back to reload:', e);
        window.location.reload();
      });
    })
    .catch(function() { proceed(); });
}
// ───────────────────────────────────────────────────────────────────────────
